import { useUserAgentInfo } from '@/context/user-agent';
import useWebLogger from '@/hooks/useWebLogger';
import { formEvent } from '@/utils/const/weblogger/event';
import Styles from './index.module.scss';
import { useEffect, useState } from 'react';
import { getFeedbackHistory, setFeedbackHistory } from './utils';
import { ThumbsDown, ThumbsUp } from '@/components/SvgIcon/icons/Thumbs';

enum FeedbackEnum {
  USELESS = 'useless',
  USEFUL = 'useful',
}

interface IProps {
  docId: string;
  docName: string;
  productName: string;
  productCode: string;
}

const ArticleFeedback = ({ docId, ...props }: IProps) => {
  const feedbackList = [
    {
      icon: <ThumbsUp />,
      text: '有帮助',
      feedback: FeedbackEnum.USEFUL,
    },
    {
      icon: <ThumbsDown />,
      text: '没帮助',
      feedback: FeedbackEnum.USELESS,
    },
  ];

  useEffect(() => {
    const feedbackTemp = getFeedbackHistory(docId);
    setSelectedFeedbackType(feedbackTemp);
  }, [docId]);

  const [selectedFeedbackType, setSelectedFeedbackType] = useState(null);

  const { clickEventRef } = useWebLogger();
  const UAInfo = useUserAgentInfo();

  const handleClick = (feedback: FeedbackEnum) => {
    setSelectedFeedbackType(feedback);
    setFeedbackHistory(docId, feedback);
    // 埋点上报
    clickEventRef.current({
      action: formEvent.ArticleUsefulFeedback,
      params: {
        userAgent: UAInfo,
        isUseful: feedback,
        docId,
        ...props,
      },
    });
  };
  return (
    <div>
      <div className={Styles['article-title']}>
        该篇文档内容是否对您有帮助？
      </div>
      <div className={Styles['article-feedback']}>
        {feedbackList.map(({ text, feedback, ...item }) => (
          <span
            className={`${Styles['feedback-item']} ${
              selectedFeedbackType === feedback &&
              Styles['feedback-item-selected']
            }`}
            key={feedback}
            onClick={() => handleClick(feedback)}
          >
            <span className={Styles['feedback-item-icon']}>{item.icon}</span>
            <span className={Styles['feedback-item-text']}>{text}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ArticleFeedback;
